function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import URITemplate from 'es6-url-template';
export class TemplateExpander {
  constructor(template) {
    _defineProperty(this, "__template", void 0);

    this.__template = template;
  }

  expand(baseOrFirst, ...models) {
    if (!this.__template.template) {
      return '';
    }

    let base = '';
    let expansionModels;

    if (typeof baseOrFirst === 'string') {
      base = baseOrFirst;
      expansionModels = models;
    } else {
      const parent = this.findNamedParent();

      if (parent) {
        base = parent.id.value;
      }

      expansionModels = baseOrFirst ? [baseOrFirst, ...models] : models;
    }

    const uriTemplate = new URITemplate(this.__template.template);
    const variables = expansionModels.reduce((variables, model) => {
      return _objectSpread(_objectSpread({}, variables), this.buildExpansionModel(this.__template.mapping, 'id' in model ? model.pointer : model));
    }, {});
    const expanded = uriTemplate.expand(variables);

    if (base) {
      return new URL(expanded, base).toString();
    }

    return expanded;
  }

  findNamedParent() {
    let parent = this.__template._parent;

    do {
      var _parent;

      if (parent && !parent.isAnonymous) {
        return parent;
      }

      parent = (_parent = parent) === null || _parent === void 0 ? void 0 : _parent._parent;
    } while (parent);

    return undefined;
  }

  buildExpansionModel(mappings, templateValues) {
    return mappings.reduce((model, mapping) => {
      const {
        property,
        variable
      } = mapping;

      if (!property || !variable) {
        return model;
      }

      const values = templateValues.out(property.id).map(({
        term
      }) => {
        const variableRepresentation = mapping.variableRepresentation || this.__template.variableRepresentation;
        return (variableRepresentation === null || variableRepresentation === void 0 ? void 0 : variableRepresentation.mapValue(term)) || term.value;
      });

      if (values.length === 0) {
        return model;
      }

      return _objectSpread(_objectSpread({}, model), {}, {
        [variable]: values
      });
    }, {});
  }

}